import axios from 'axios'
import logsErrorResponse from './interceptors/LogsErrorResponse'
import authenticatesRequest from './interceptors/AuthenticatesRequest'
import showToastOnFailedResponse from './interceptors/ShowToastOnFailedResponse'

const client = axios.create({
  headers: {
    common: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  },
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: process.env.VUE_APP_API_TIMEOUT
})
showToastOnFailedResponse(client)
logsErrorResponse(client)
authenticatesRequest(client)

export default client
